import { HyperLinkBuilder } from "../../../../commonComponents/inline/hyperLink";
import { getImagesSrc, SiteSimpleImage } from "../../../../commonComponents/inline/siteSimpleImage";
import { SiteArticleSocialShareNew1280 } from "../../../article/componentas/articleSocialShare1280Component/articleSocialShareNew1280";
import { MenuItems } from "./galhadHeaderComponenta";

interface Props {
    menuLogosItems: MenuItems[]
    menuItems: MenuItems[]
    sitename: string
    isArticlePage: boolean
    showPicture?: boolean
    imageId: string
    imagesDomain: string
}

interface State {
    hasScrolled: boolean
    currentPathname: string
}
export class GalhadHeaderComponentaContentRedesign extends React.Component<Props, State> {
    public static siteScriptName = "GalhadHeaderComponentaContentRedesign"
    constructor(props) {
        super(props)
        this.state = {
            hasScrolled: false,
            currentPathname: "",
        }
    }
    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        this.setState({ currentPathname: window.location.pathname });
    }

    private getLinkPathname = (link: string) => {
        try {
            return new URL(link, "https://placeholder.local").pathname;
        } catch (e) {
            return link;
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    private handleScroll = () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const shouldHaveScrolledClass = scrollTop > 70; // Adjust threshold as needed

        if (shouldHaveScrolledClass !== this.state.hasScrolled) {
            this.setState({ hasScrolled: shouldHaveScrolledClass });
        }
    }

    render() {
        const { menuLogosItems, menuItems, sitename, isArticlePage, showPicture, imageId, imagesDomain } = this.props
     
        const urlLogo = getImagesSrc(imagesDomain, imageId);

        return (
            <>
            <div className={`GalhadHeaderComponentaRedesign ${this.state.hasScrolled ? "hasScrolled" : ""}`}  style={{ background: "#fff", transition: "background 0.1s"}}>
                <div className="galhadHeaderContent">
                <div className="sideLogoLinks">
                    {_.map(menuLogosItems, (item, index) => {
                        return (
                            <HyperLinkBuilder href={item.link} linkTarget={item.linkTarget} className="sideLink" key={index}>
                                {item.url !== "" && <SiteSimpleImage src={item.url} maxHeight={42} title={item.title} />}
                            </HyperLinkBuilder>

                        )
                    })}
                </div>
                <div className="divider">|</div>
                <div className="navLinks">
                    {_.map(menuItems, (item, index) => {
                        const isActive = this.state.currentPathname !== "" && this.state.currentPathname === this.getLinkPathname(item.link);
                        return (
                            <HyperLinkBuilder href={item.link} linkTarget={item.linkTarget} className="sideLink" style={isActive ? { fontWeight: "bold" } : {}} key={index}>
                                {item.title}
                            </HyperLinkBuilder>

                        )
                    })}
                </div>

                <SiteArticleSocialShareNew1280
                    categorySubChannel={""}
                    author={""}
                    articleId={""}
                    isBottomButtons={false}
                    showComments={false}
                    isSpotim={false}
                    lang={sitename === "ynetnews" ? "gE" : "gH"}
                    titleForMail={isArticlePage ? (sitename === "ynetnews" ? '' : 'ז"ל') : ''}
                />
                </div>

            </div>
            {showPicture &&
                <div className="GalHadshowPicture">
                    <SiteSimpleImage src={urlLogo} aria-hidden="true" aria-label="Logo" className="logoImage" />
                </div>
            }
            </>
        )

    }
} 